import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'En solo 2 noches, mi bebé empezó a calmarse y yo volví a dormir. ¡Gracias por esta guía!',
  name: 'Laura M.',
  image: 'https://cdn.magicpatterns.com/uploads/sRVXpvYNZqSkizDpQrAAvv/thumb.png'
}, {
  quote: 'Había intentado de todo. El Método de Micropausas fue el único que respetó mi cansancio.',
  name: 'Ana G.',
  image: 'https://cdn.magicpatterns.com/uploads/9kYYjsUrFWUe3tnVu1Sn4q/thumb.png'
}, {
  quote: 'Mi pareja y yo ya no discutimos a medianoche. Funciona en equipo.',
  name: 'Carolina F.',
  image: 'https://cdn.magicpatterns.com/uploads/phUStf1jQrW6SqLM9PHPD1/thumb.jpg'
}];
export function ProofSection() {
  return <section className="py-20 bg-accent/10" data-id="element-292">
      <div className="max-w-5xl mx-auto px-6" data-id="element-293">
        <FadeIn data-id="element-294">
          <div className="text-center mb-12" data-id="element-295">
            <div className="flex justify-center gap-2 mb-6" data-id="element-296">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 text-accent fill-accent" data-id="element-297" />)}
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-brown-dark" data-id="element-298">
              Lo que dicen las mamás que ya lo probaron
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-299">
          {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.15} direction="up" data-id="element-300">
              <div className="bg-white p-8 rounded-3xl shadow-sm border border-accent/20 h-full flex flex-col" data-id="element-301">
                <Quote className="w-8 h-8 text-accent/30 mb-4 flex-shrink-0" data-id="element-302" />
                <p className="text-lg text-brown-dark leading-relaxed font-serif italic flex-1" data-id="element-303">
                  "{t.quote}"
                </p>
                <div className="mt-6 flex items-center gap-3" data-id="element-304">
                  {t.image ? <img src={t.image} alt={`Foto de ${t.name}`} className="w-12 h-12 rounded-full object-cover border-2 border-accent/30 flex-shrink-0" data-id="element-305" /> : <div className="w-12 h-12 rounded-full bg-accent/15 flex items-center justify-center flex-shrink-0" data-id="element-306">
                      <span className="font-bold text-accent text-lg" data-id="element-307">
                        {t.name.charAt(0)}
                      </span>
                    </div>}
                  <div data-id="element-308">
                    <p className="font-bold text-brown-dark text-sm tracking-wide" data-id="element-309">
                      {t.name}
                    </p>
                    <p className="text-xs text-brown/60" data-id="element-310">Mamá verificada</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}